import { Component, OnInit } from '@angular/core';
import { NbCardModule, NbRouteTabsetModule } from '@nebular/theme';

@Component({
  selector: 'app-campaign-analytics',
  templateUrl: './campaign-analytics.component.html',
  styleUrls: ['./campaign-analytics.component.css'],
  imports: [NbCardModule, NbRouteTabsetModule]
})
export class CampaignAnalyticsComponent implements OnInit {
  public tabs: any[] = [
    {
      title: $localize`Deliveries`,
      route: 'deliveries'
    }
  ];

  constructor() {}

  public ngOnInit() {}
}
